export const getDayMonthYear = (timestamp: string): string => {
  const date = new Date(timestamp);
  const day = toDoubleDigit(date.getDate());
  const month = toDoubleDigit(date.getMonth() + 1);
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const getHourMinute = (timestamp: string): string => {
  const date = new Date(timestamp);
  const hour = toDoubleDigit(date.getHours());
  const minutes = toDoubleDigit(date.getMinutes());
  return `${hour}:${minutes}`;
};

export const getTimeAndDateInfo = (timestamp?: string): { date: string; hour: string } | undefined => {
  {
    /* TODO-EMA: capire come trasformare timestamp in base alla timezone  */
  }
  return timestamp
    ? {
        date: getDayMonthYear(timestamp),
        hour: getHourMinute(timestamp),
      }
    : undefined;
};

export const millisecondToFormattedTime = (ms: number): { hours: number; minutes: number; seconds: number } => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { hours, minutes, seconds };
};

const toDoubleDigit = (number: number): string => {
  return `${number < 10 ? '0' + number : number}`;
};
